import React, { useCallback } from "react";
import cn from "classnames";
import style from "../common.module.scss";
import LineIcon from "../../../shared/icons/LineIcon";
import KazahstanIcon from "../../../shared/icons/country/KazahstanIcon.png";
import RussianIcon from "../../../shared/icons/country/RussianIcon.png";
import UsbekistanIcon from "../../../shared/icons/country/UsbekistanIcon.png";
import LineFlexIcon from "../../../shared/icons/LineFlexIcon";
import {t} from "i18next";

const OrdersInfoAddressList = ({ addressList, order }) => {
  const formatDate = useCallback((dateString) => {
    const date = new Date(dateString);
    const optionsDate = { day: "numeric", month: "short" };
    const optionsWeekday = { weekday: "short" };

    let formattedDate = date.toLocaleDateString("ru-RU", optionsDate);
    let formattedWeekday = date.toLocaleDateString("ru-RU", optionsWeekday);

    return `${formattedDate.replace(".", "")}, ${formattedWeekday.replace(".", "")}`;
  }, []);

  const formatTime = useCallback((hour) => {
    return `${hour.toString().padStart(2, "0")}:00`;
  }, []);

  const countryIcons = {
    "63556b49614a6ddc9ceeb61e": KazahstanIcon,
    "63556bc1614a6ddc9ceeb61f": RussianIcon,
    "648b0836d64a46fc66c74273": UsbekistanIcon,
  };

  const baseHeight = 60;
  const lineHeight = baseHeight * addressList?.length;

  return (
    <div className={cn(style.shipping_wrapper)}>
      {addressList && addressList.length > 2 ? (
        <LineFlexIcon height={lineHeight} />
      ) : (
        <LineIcon />
      )}
      <div className={style.shipping_content}>
        {addressList &&
          addressList.map((address, index) => {
            const isStart = address.step === 1;
            const isEnd = index === addressList.length - 1;

            let pointType = t('intermediatePointTitle');
            if (isStart) pointType = t("common.tableHead.from");
            if (isEnd) pointType = t("common.tableHead.to");

            let recipientType = t('ordersCreate.view.label.recipient');
            if (isStart) recipientType = t('ordersCreate.view.label.sender');

            return (
              <React.Fragment key={address.id || index}>
                <div className={style.shipping_column}>
                  <span className={style.shipping_column_head}>
                    {address.type === "Loading" ? t('balanceList.loading') : t('balanceList.unloading')}
                  </span>
                  <div className={style.shipping_column_text}>
                    {formatDate(address?.shippingDate)}
                  </div>
                  <div className={style.shipping_column_footer}>
                    {formatTime(address?.shippingHourFrom)} - {" "}
                    {formatTime(address?.shippingHourTo)}
                  </div>
                </div>

                <div className={style.shipping_column}>
                  <span className={style.shipping_column_head}>{pointType}</span>
                  <div className={style.shipping_column_main}>
                    <img
                      src={countryIcons[address?.countryId]}
                      className={style.shipping_column_countryIcon}
                      alt={t('ordersCreate.view.label.country')}
                    />
                    <div className={style.shipping_column_text}>{address?.cityName}</div>
                  </div>
                  <div className={style.shipping_column_footer}>{address?.address}</div>
                </div>

                <div className={style.shipping_column}>
                  <span className={style.shipping_column_head}>{recipientType}</span>
                  <div className={style.shipping_column_text}>
                    {index === 0 ? order?.senderName : address?.recipientName}
                  </div>
                  <span className={style.shipping_column_footer}>
                    {index === 0
                      ? order?.senderPhoneNumber
                      : address?.recipientPhoneNumber}
                  </span>
                </div>
              </React.Fragment>
            );
          })}
      </div>
    </div>
  );
};

export default OrdersInfoAddressList;
